import type { ReactElement } from "react";

import styles from "./Skeleton.module.css";

/** The placeholder shapes the mockup's loading states use. */
export type SkeletonShape = "line" | "title" | "block" | "thumb" | "circle";

/** Width steps, so a stack of lines reads as text and not as a wall. */
export type SkeletonWidth = "full" | "threeQuarters" | "half" | "third";

export interface SkeletonProps {
  readonly shape?: SkeletonShape | undefined;
  readonly width?: SkeletonWidth | undefined;
}

/**
 * A shimmering placeholder (the mockup's `.sk`).
 *
 * Hidden from assistive technology: a list of grey bars says nothing. The region that holds the
 * skeletons carries `role="status"` and the "Cargando…" text, so the load is announced once.
 * The shimmer stops under `prefers-reduced-motion`.
 */
export function Skeleton({ shape = "line", width = "full" }: SkeletonProps): ReactElement {
  return <span className={[styles.skeleton, styles[shape], styles[width]].join(" ")} aria-hidden="true" />;
}
